export default {
  carrera: {},
  carreras: [],
  fields: {},
  errorArray: [],
  dialog: false,
};
